var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 14",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3544 8.31589L17.714 12.8424C17.5085 13.1946 17.2143 13.4869 16.8607 13.69C16.507 13.8931 16.1063 14 15.6985 14H1.11651C0.441195 14 0.0204288 13.2674 0.360695 12.6841L3.00115 8.15763C3.20664 7.80536 3.50086 7.51311 3.8545 7.31C4.20813 7.10688 4.60883 7 5.01664 7H19.5987C20.274 7 20.6947 7.73256 20.3544 8.31589ZM5.01664 5.83333H16.975V4.08333C16.975 3.11682 16.1915 2.33333 15.225 2.33333H9.39164L7.05831 0H1.22498C0.258465 0 -0.525024 0.78349 -0.525024 1.75V11.8871L1.99341 7.56977C2.6182 6.4987 3.77666 5.83333 5.01664 5.83333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.34f465c6c197b88e8614e857da0eecd2.svg";
export { ForwardRef as ReactComponent };